/**
 * ArticleHeaderCategory
 */
import React from 'react';
import clsx from 'clsx';
import { Link as LinkBase } from 'ui-component-library/base';
/** Main description for this component. */
var ArticleHeaderCategory = function (_a) {
    var text = _a.text, url = _a.url, _b = _a.LinkComponent, LinkComponent = _b === void 0 ? LinkBase : _b, className = _a.className;
    var Link = LinkComponent;
    return (React.createElement("li", { className: clsx(className, 'inline-block'), "data-cid": "ArticleHeaderCategory" }, url ? (React.createElement(Link, { to: url, className: "text-teal hover:underline" }, text)) : (React.createElement("span", { className: "text-greyDarker" }, text))));
};
export default ArticleHeaderCategory;
